export const toNumber = (str, fallback = 0) => {
	if (!str)
		return fallback;

	return Number(str.replace('px', ''));
}